import React, { useState, useContext } from 'react';
import _ from 'lodash';
import styled from 'styled-components';
import { useMutation, useQuery } from 'react-apollo';
import { Modal, ModalBody, ModalFooter, Button, Badge } from 'reactstrap';
import { useHistory } from 'react-router-dom';
import { DeleteBroadcastMutation, GetBroadcastsQuery } from 'graphql/chat';
import { UserContext } from 'context/UserContext';
import { Colors } from 'assets/colors/Colors';
import moment from 'moment';
import NewTableList from 'components/TableList/NewTable';
import { errorNotify, successNotify } from '../../utils/toaster';
import { truncateText } from 'helpers/truncateText';

const limit = 20;

const initialRowData = {
	channelId: '',
	playlistId: '',
	channelName: '',
	loungeId: '',
	loungeName: '',
};

const Broadcasts = () => {
	const [offset, setOffset] = useState(0);
	const [rowData, setRowData] = useState(initialRowData);
	const [deleteModal, setDeleteModal] = useState(false);
	const { user } = useContext(UserContext);
	const [deleteBroadcast, { loading: deleting }] =
		useMutation(DeleteBroadcastMutation);
	const history = useHistory();

	const { data: broadcastsData, loading: loadingBroadcasts } = useQuery(GetBroadcastsQuery, { 
		variables: { 
			userId: user?.id 
		}, 
		fetchPolicy: 'cache-and-network'
	})

	const handleDeleteBroadcast = async (id) => {
		try {
			await deleteBroadcast({
				variables: { id },
				refetchQueries: [{ query: GetBroadcastsQuery, variables: { userId: user?.id } }],
			});
			successNotify('Broadcast Deleted Successfully');
		} catch (e) {
			console.error(e.message);
			errorNotify('Unable To Delete Broadcast');
		} finally {
			setDeleteModal(false);
			setRowData(initialRowData);
		}
	};

	const data = _.map(
		broadcastsData?.chat || [],
		({
			id,
			isBroadcastLive,
			broadcastImage,
			broadcastTitle,
			broadcastMessage,
			createdAt
		}) => ({
			id,
			status: (
			 <div>
				<Badge 
					color={`${isBroadcastLive ? 'success' : 'warning'}`} 
					className='px-4 py-1'
				>
					{isBroadcastLive ? 'Live' : 'Draft'}
				</Badge>
			 </div>
			),
			image: (
				<img
          src={broadcastImage}
          alt="image"
          width={54}
          height={54}
          style={{ 
						borderRadius: 50, 
						backgroundColor: Colors.gray200 
					}}
        />
			),
			title: truncateText(broadcastTitle, 30),
			message: truncateText(broadcastMessage, 30),
			created: moment(createdAt).fromNow(),
			Actions: (
				<div>
					<Button 
						color='primary' 
						className='mr-3'
						onClick={() => {
							history.push(`/broadcasts/${id}`);
						}}
					>Preview</Button>
					<Button 
						color='danger'
						onClick={() => {
							setRowData({ id });
							setDeleteModal(true);
						}}
					>Delete</Button>
				</div>
			),
		})
	);

	const columns = [
		{ id: 1, title: 'Status' },
		{ id: 2, title: 'Image' },
		{ id: 3, title: 'Title' },
		{ id: 4, title: 'Message' },
		{ id: 5, title: 'Created' },
		{ id: 6, title: 'Actions' },
	];

	return (
		<Wrapper>
			<div>
				<NewTableList
					data={data}
					columns={columns}
					title='Broadcasts'
					totalCount={0}
					limit={10}
					setOffset={setOffset}
					// paginate
					loading={false}
					actions={{
						title: 'Hide',
						background: Colors.red200,
						color: Colors.red800,
					}}
					actionBtn={
						<ActionBtn>
							<Button
								color={'success'}
								onClick={() => {
									history.push('/new-broadcast');
								}}
							>
								New Broadcast
							</Button>
						</ActionBtn>
					}
				/>
			</div>
			<Modal isOpen={deleteModal} centered={true}>
				<ModalBody>
					<p>
						Are you sure you want to delete broadcast ?
					</p>
				</ModalBody>
				<ModalFooter>
					<Button
						color='info'
						onClick={() => {
							setDeleteModal(false);
							setRowData(initialRowData);
						}}
					>
						No
					</Button>{' '}
					<Button
						color='danger'
						onClick={async () => {
							try {
								setDeleteModal(false);
								await handleDeleteBroadcast(rowData.id);
							} catch (e) {
								errorNotify('Unable To Delete Data');
							} finally {
								setRowData(initialRowData);
							}
						}}
					>
						Yes
					</Button>
				</ModalFooter>
			</Modal>
		</Wrapper>
	);
};

const Wrapper = styled.div`
	height: 100vh;
	padding: 50px;
	padding-top: 15vh;
	overflow-y: auto;
`;

const ActionBtn = styled.div`
	position: absolute;
	top: 20px;
	right: 20px;
`;

const IconContainer = styled.div`
	padding: 10px 0px;
	width: 50%;
	cursor: pointer;
`;

export default Broadcasts;
